import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^sif\/au\//, '');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey('sif/au/' + key);
  }
}
